// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh5[data-v-435fe576] {\n  color: var(--sea);\n  font-size: 1.4rem;\n  font-weight: 400 !important;\n}\n.trending-icon[data-v-435fe576] {\n  width: 25px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
